import { useEffect, useState } from "react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from "react-router";
import { ip } from "../../config";
import SpinLoader from "../Miscel/SpinLoader";

import React from 'react'
import ReactSelect from "react-select";

const AddEvent = () => {

    function dateReducer(s) {
        if (s == null) return null;
        var res = s.includes("T") ? s.split("T")[0] : s;
        res = res.split("-").join("-");
        return res;
    }

    const notify = (message) => toast.success(message, { position: "top-center" });
    const navigate = useNavigate();
    const [eventId, setEventId] = useState(0);
    const urlParams = new URLSearchParams(window.location.search);
    const updatingEvent = urlParams.get('update');
    const updatingEventId = urlParams.get('eventId');
    const [cardInfo, setCardInfo] = useState({});

    useEffect(() => {
        if (!localStorage.getItem('sessionKey')) {
            window.location.href = "/";
        }

        document.getElementById("spinloader").classList.add("invisible");

        if (updatingEvent === "true") {
            fetch(ip + "/events/" + updatingEventId).
                then(res => {
                    if (res.status !== 200) throw new Error("Event not found")
                    return res.json();
                }).then(data => {
                    setCardInfo(data);
                }
                );
        }
    }, []);


    function addNewAlumniEvent(e) {
        e.preventDefault();
        document.getElementById("spinloader").classList.remove("invisible");
        if (localStorage.getItem("sessionKey") == null || localStorage.getItem("sessionKey") == undefined || localStorage.getItem("sessionKey") == "") {
            window.location.href = "/login";
        }
        fetch(ip + "/events", {
            method: "POST",
            headers: { "Content-Type": "application/json", "Authorization": "Basic " + localStorage.getItem("sessionKey") },
            body: JSON.stringify({
                "alumniName": document.getElementById("name").value,
                "alumniDepartment": document.getElementById("department").value,
                "alumniPassedOut": document.getElementById("passedOut").value,
                "eventPurpose": document.getElementById("purpose").value,
                "eventInDetail": document.getElementById("detail").value,
                "eventStartDate": document.getElementById("startDate").value,
                "eventEndDate": document.getElementById("endDate").value,
                "conductedBy": document.getElementById("conductedBy").value,
                "noOfHours": document.getElementById("hours").value,
                "photos": []
            })
        }).then(response => {
            if (response.status == 401) {
                alert("Login again please");
                localStorage.clear();
                navigate("/login");
                return;
            }
            if (response.status === 201) {
                notify("Event Added Successfully.. Redirecting");
                return response.json();
            }
            alert("Error in adding event. Contact admin");

        }).then(data => {
            // navigate("/event/"+data.id);
            console.log(data);
            setEventId(data.id);
            console.log(data.id);

            setTimeout(() => {
                navigate("/event/" + data.id);
            }, 2000);

        }
        ).catch(error => {
            console.log(error);
        });

    }

    function updateAlumniEvent(event) {
        event.preventDefault();
    }



    return (
        <div className="container">
            <SpinLoader />
            <ToastContainer />

            <form className="form-horizontal event-form" id="form-1">

                <div className="d-flex justify-content-between alumniInfoForm">
                    <div className="form-group">
                        <label htmlFor="exampleInputEmail1">Alumni Name:</label>
                        <input type="text" required className="form-control" defaultValue={cardInfo.alumniName} id="name" aria-describedby="emailHelp" placeholder="Enter Alumni Name" />
                    </div>
                    <div className="form-group">
                        <label htmlFor="exampleInputPassword1">Alumni Passout Year:</label>
                        <input type="year" defaultValue={cardInfo.alumniPassedOut} required className="form-control" id="passedOut" placeholder="Enter Alumni Batch" />
                    </div>
                    <div className="form-group">
                        <label htmlFor="exampleInputPassword1">Alumni Department:</label>
                        <select required className="form-control" defaultValue={cardInfo.alumniDepartment} id="department">
                            <option value="">Select Alumni's Dept</option>
                            <option value="IT">IT</option>
                            <option value="CSE">CSE</option>
                            <option value="ECE">ECE</option>
                            <option value="MECH">MECH</option>
                            <option value="EEE">EEE</option>
                            <option value="Civil">Civil</option>
                        </select>
                    </div>
                </div>

                <hr />

                <div className="d-flex alumniInfoForm">
                    <div className="form-group m-1">
                        <label htmlFor="exampleInputPassword1">Purpose:</label>                                            
                        <select required className="form-control" id="purpose">
                            <option value="">Select Purpose</option>
                            <option value="Academic Council Meeting" >Academic Council Meeting</option>
                            <option value="Board of studies" selected="selected">Board of studies</option>
                            <option value="Workshops">Workshops</option>
                            <option value="MoU">MoU</option>
                            <option value="Placement">Placement</option>
                            <option value="Guest Lecture">Guest Lecture</option>
                            <option value="Seminars">Seminars</option>
                            <option value="Indcution Program">Induction Program</option>
                            <option value="Incybation Centre">Incubation Center</option>
                            <option value="Soft/Communcation Skills">Soft/Communcation Skills</option>
                            <option>Others</option>
                        </select>
                    </div>
                    <div className="form-group m-1">
                        <label htmlFor="exampleInputPassword1">No of hours</label>
                        <input type="number" defaultValue={cardInfo.noOfHours} required className="form-control" id="hours" placeholder="Enter No of hours" />
                    </div>
                </div>

                <div className="form-group">
                    <label htmlFor="exampleInputPassword1">Description:</label>
                    <textarea style={{ minHeight: "200px" }} defaultValue={cardInfo.eventInDetail} required className="form-control" id="detail" placeholder="Enter Purpose Description" />
                </div>

                <div className="d-flex justify-content-between alumniInfoForm">
                    <div className="form-group">
                        <label htmlFor="exampleInputPassword1">Start Date:</label>
                        <input type="date" required defaultValue={dateReducer(cardInfo.eventStartDate)} className="form-control" id="startDate" placeholder="Enter Start Date" />

                    </div>

                    <div className="form-group">
                        <label htmlFor="exampleInputPassword1">End Date:</label>
                        <input type="date" required defaultValue={dateReducer(cardInfo.eventEndDate)} className="form-control" id="endDate" placeholder="Enter End Date" />
                    </div>

                    <div className="form-group">
                        <label htmlFor="exampleInputPassword1">Conducted by:</label>
                        <input type="text" required defaultValue={cardInfo.conductedBy} className="form-control" id="conductedBy" placeholder="Enter Conducted By" />
                    </div>
                </div>


                <div className="d-flex flex-row-reverse">
                    {
                        updatingEvent === "true" ?
                            <button type="submit" onClick={(e) => updateAlumniEvent(e)} className="btn btn-primary mt-3">Update Event</button>
                            :
                            <button type="submit" onClick={(e) => addNewAlumniEvent(e)} className="btn btn-primary mt-3">Add Event</button>

                    }
                </div>


            </form>


        </div>
    );
}

export default AddEvent;